<template>
  <div class="friend-button" @click="toline">
    <img src="/static/img/lp/campaign/lineCampaign202110/friend_btn.png">
  </div>
</template>

<script>

export default {
  name: 'FriendButton',
  methods:{
    toline(){
      window.gtag('event', 'click', {
        'event_category': 'LINE-campaign-add-friend-button',
        'event_label': 'LINE-campaign-202110',
      })
      //window.open('https://lin.ee/CxoTFVj', '_blank')
      window.open('https://liff.line.me/1656812190-7Ne8L3nP/landing?follow=%40401ymcbi&lp=YUu5D1&liff_id=1656812190-7Ne8L3nP', '_blank')
    }
  }
}</script>

<style scoped lang="scss">
.friend-button {
  cursor: pointer;
  img {
    display: block;
    width: 100px;
    height: 100px;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/lp/campaign/LineCampaign202110/partials/FriendButton.vue